export const reloadPage = () => {
  window.location.reload();
};
// can't test this function because can't mock window.location after JSDOM v26
